import * as React from 'react'
import { styled } from 'next-yak'

import { Icon } from '../Icon'
import { type SpecificIconProps } from '../types'
import { lightweight, standalone, type SymbolProps } from '../../spritesheetUtils'

const ID = 'spotify-third-party-glyph-icon'

export function SpotifySymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <g>
        <path
          fillRule="evenodd"
          d="M10.434 1.021c2.712-1.06 5.528-1.263 8.393-.755 6.557 1.164 11.777 6.302 12.898 12.842.99 5.768-.697 10.715-4.965 14.717-2.511 2.356-5.542 3.68-8.972 4.066-.153.017-.307.031-.46.043l-.922.066h-.803c-2.157-.07-4.234-.512-6.191-1.422-3.833-1.781-6.583-4.623-8.22-8.524-.758-1.806-1.12-3.7-1.191-5.652-.01-1.374.089-2.739.433-4.072 1.415-5.462 4.744-9.254 10-11.309Zm4.576 18.22c-2.532-.17-5.026.112-7.492.677-.58.133-.914.627-.8 1.16.122.58.62.906 1.218.78 1.375-.293 2.758-.525 4.163-.616 3.489-.225 6.805.322 9.843 2.15a.997.997 0 0 0 1.398-.314c.314-.506.137-1.092-.426-1.43-2.434-1.46-5.085-2.216-7.904-2.407Zm-1.673-5.26c-1.007-.01-2.01.056-3.008.182a19.712 19.712 0 0 0-3.409.725 1.24 1.24 0 0 0 .54 2.417c.21-.03.414-.103.62-.158 2.629-.709 5.295-.822 7.986-.489 2.683.332 5.225 1.093 7.558 2.493.585.352 1.324.144 1.679-.431a1.23 1.23 0 0 0-.387-1.687 13.248 13.248 0 0 0-1.635-.894c-3.147-1.49-6.478-2.138-9.944-2.157Zm.205-5.51c-.637.018-1.446.023-2.254.084-1.778.135-3.531.405-5.243.912-.373.11-.669.326-.872.661a1.502 1.502 0 0 0 .08 1.68c.389.519 1.005.713 1.695.511 1.726-.505 3.493-.739 5.283-.824a29.899 29.899 0 0 1 6.013.313c2.538.393 4.977 1.084 7.223 2.374.762.439 1.67.18 2.077-.557.403-.731.144-1.602-.61-2.043a18.967 18.967 0 0 0-3.514-1.59c-3.147-1.064-6.394-1.501-9.878-1.521Z"
          clipRule="evenodd"
        />
      </g>
    </symbol>
  )
}

const SpotifyStandaloneContent = standalone(SpotifySymbol, ID)

export const Spotify = styled(function SpotifyStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-spotify">
      <SpotifyStandaloneContent />
    </Icon>
  )
})``

export const SpotifyLightweight = styled(function SpotifyComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-spotify">
      {lightweight(ID)}
    </Icon>
  )
})``
